import { Injectable } from '@angular/core';

@Injectable()
export class FilterService {
  filterArray(list: Array<any>, args:any, attr: Array<any>) {
    var filter: any;
    var item2: any;
    var tt: any;
    var attrSplit: Array<string>;

    var filter2 = list.filter(item => {
      for (let key in attr) {
        attrSplit = attr[key].split(".");
        item2 = item;

        for (let keyY in attrSplit) {
          tt = item2[attrSplit[keyY]];
          if (tt) {
            item2 = tt;
          } else {
            break;
          }
        }

        if (typeof args === 'string') {
          filter = (args || '').toLowerCase();
          filter = removeAccents(filter);

          item2 = item2.toString();
          item2 = item2.toLowerCase();
          item2 = removeAccents(item2);
          if (item2.indexOf(filter) != -1) {
            return item;
          }
        } else {
          filter = args;

          if (item2 === filter) {
            return item;
          }
        }
      }
    });

    function removeAccents(value: any) {
      return value
        .replace(/á/g, 'a')
        .replace(/â/g, 'a')
        .replace(/à/g, 'a')
        .replace(/ã/g, 'a')
        .replace(/é/g, 'e')
        .replace(/è/g, 'e')
        .replace(/ê/g, 'e')
        .replace(/í/g, 'i')
        .replace(/ì/g, 'i')
        .replace(/î/g, 'i')
        .replace(/ó/g, 'o')
        .replace(/ò/g, 'o')
        .replace(/ô/g, 'o')
        .replace(/õ/g, 'o')
        .replace(/ú/g, 'u')
        .replace(/ù/g, 'u')
        .replace(/û/g, 'u')
        .replace(/ç/g, 'c');
    }

    return filter ? filter2 : list;
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/services/filter.service.ts
 **/